import header from "./house-example-cuts-and-views.png";
import section1 from "./schnitte-von-haeusern.webp";
import section2 from "./ansicht-eines-hauses.webp";
import section3 from "./example-cuts-and-views.webp";

export { header, section1, section2, section3 };
